import axios from "axios";
import $ from 'zepto';
import reportJsError from '@/global/js_report.js'

// axios 配置
axios.defaults.timeout = 30000;
// axios.defaults.baseURL = 'https://action.fenqile.com';
axios.defaults.baseURL = `${location.protocol}//${location.host}`;

// http request 拦截器
axios.interceptors.request.use(
    config => {
        // console.log("************ interceptors.request");
        // console.log(config);
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
        // if (response.data.errno === 999) {
        //     router.replace("/");
        //     console.log("token过期");
        // }
        // console.log('****************interceptors.response');
        // console.log(response)
        let outerData = response.data;
        if(!outerData.retmsg){ //如果retmsg没有值，说明是网关请求，res_info有值
            outerData.retcode = outerData.result;
            outerData.retmsg = outerData.res_info;
            delete outerData.result;
            delete outerData.res_info;
        }
        
        let retcode = parseInt(outerData.retcode, 10);
        if(retcode == 0){
            if(outerData.data){ //有两层则取内层data去掉
                let innerData = outerData.data;
                innerData.retcode = innerData.result;
                innerData.retmsg = innerData.res_info;
                innerData.system = outerData.system;
                delete innerData.result;
                delete innerData.res_info;
                if(innerData.retcode != 0){
                    let msg = $.extend({'_url_':response.config.url}, innerData);
                    reportJsError({
                        code: '913820004',//后台内部错误码上报
                        action: 'ajax-inside-error',
                        msg: msg
                    });
                }
                response.data = innerData;
            }
        }else{
            let msg = $.extend({'_url_':response.config.url}, outerData);
            reportJsError({
                code: '913820003',//后台外部错误码上报
                action: 'ajax-outside-error',
                msg: msg
            });
            response.data = outerData;
        }
        return response;
    },
    err => {
        if(err.response.status == 404){
            reportJsError({
                code: '913820001',//404错误上报
                action: 'js-404-error',
                msg: location.href
            });
        }
        if(err.response.status == 500){
            reportJsError({
                code: '913820002',//404错误上报
                action: 'js-500-error',
                msg: location.href
            });
        }
        return Promise.reject(err);
    }
);
export default axios;
